<template>
  <v-dialog scrollable v-model="isShowDialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">修改密碼</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-form ref="form" v-model="isFormValid" :lazy-validation="true">
            <v-row>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="form.old"
                    label="舊密碼"
                    type="password"
                    :rules="formRules.password"/>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="form.new"
                    label="新密碼"
                    type="password"
                    :rules="formRules.newPassword"/>
                </v-col>
                <v-col cols="12" sm="12" md="12">
                  <v-text-field
                    v-model="form.confirm"
                    label="再次確認密碼"
                    type="password"
                    :rules="formRules.confirmNewPassword"/>
                </v-col>
              </v-row>
          </v-form>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="white darken-1" depressed outlined text @click="close">取消</v-btn>
        <v-btn color="white darken-1" depressed outlined text :disabled="!isFormValid" @click="save">儲存</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate color="white"></v-progress-circular>
    </v-overlay>

  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data: () => ({
    isLoading: false,
    // form
    isFormValid: true,
    form: {},
    defaultForm: {
      old: "",
      new: "",
      confirm: ""
    }
  }),
  computed: {
    formRules() {
      return {
        newPassword: [v => !!v || "請輸入密碼"],
        password: [v => !!v || "請輸入密碼"],
        confirmNewPassword: [v => v === this.form.new || "兩次輸入新密碼不同"]
      };
    },
    isShowDialog: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      }
    }
  },
  methods: {
    close() {
      this.isShowDialog = false;
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;
      this.$services.user
        .updatePassword(this, this.form)
        .then(res => {
          this.$emit("updated");
          this.close();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetForm() {
      this.form = JSON.parse(JSON.stringify(this.defaultForm));
      if (this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created() {
    this.resetForm();
  },
  watch: {
    isShowDialog(val) {
      if (val) this.resetForm();
    }
  }
};
</script>